<template>
  <section id="donate" class="container mt4">
    <p class="subhead">donate to unite the bride</p>
    <h2 class="h2 serif fw700 mtq">Help us unite charity with intelligence.</h2>
    <div class="container bg-gray0 mt1 pv1">
      <div class="container-main">
        <div class="cols-6">
          <div class="donate-form">
            <div action="" id="donate-form">
              <div class="donate-form-section-amount">
                <div class="fw700">Amount</div>
                <div class="donate-form-amount-field">
                  <label class="donate-form-field mr1-lg" for="stripe-amount">
                    <cleave id="stripe-amount"
                      class="donate-form-input donate-form-input-amount"
                      name="amount"
                      size="7"
                      placeholder="$0"
                      v-model="form.amount"
                      v-validate="'required|min_value:1'"
                      data-vv-validate-on="blur"
                      @blur.native="validate('amount')"
                      :options="formOptions.amount"></cleave>
                  </label>
                  <div class="donate-form-error">{{errors.first('amount')}}</div>
                  <div class="donate-form-amount-buttons">
                    <span class="donate-form-amount-button button button-primary"
                      tabindex="0"
                      v-for="d in donateAmounts"
                      @click="setAmount(d.amount)">${{d.amount}}</span>
                  </div>
                </div>
              </div>
              <div class="donate-form-section">
                <div class="donate-form-monthly mt1">
                  <label for="stripe-monthly" class="checkbox fw700">
                    Make this a monthly contribution
                    <input id="stripe-monthly"
                      name="monthly"
                      type="checkbox"
                      v-model="form.monthly">
                    <span class="checkmark"></span>
                  </label>
                </div>
              </div>
              <!-- <p class="p mt1">$100 can provide 1 hour of training for human trafficking investigation</p> -->
              <div class="donate-form-section donate-form-card">
                <label class="donate-form-field donate-form-field-card-number mt2" for="stripe-card-number">
                  <div class="fw700">Card Number</div>
                  <cleave id="stripe-card-number"
                    class="donate-form-input"
                    name="cardNumber"
                    size="19"
                    placeholder="•••• •••• •••• ••••"
                    v-model="form.cardNumber"
                    v-validate="'required|credit_card'"
                    data-vv-validate-on="blur"
                    @blur.native="validate('cardNumber')"
                    :options="formOptions.cardNumber"></cleave>
                  <div class="donate-form-error">{{errors.first('cardNumber')}}</div>
                </label>
                <label class="donate-form-field donate-form-field-expiration mt1-sm mt1-md mt2-lg" for="stripe-expiration">
                  <div class="fw700">Expiration</div>
                  <cleave id="stripe-expiration"
                    class="donate-form-input"
                    name="expiration"
                    size="5"
                    placeholder="MM/YY"
                    v-model="form.expiration"
                    v-validate="'required|min:4'"
                    data-vv-validate-on="blur"
                    @blur.native="validate('expiration')"
                    :options="formOptions.expiration"></cleave>
                    <div class="donate-form-error">{{errors.first('expiration')}}</div>
                </label>
                <label class="donate-form-field donate-form-field-cvc mt1-sm mt1-md mt2-lg" for="stripe-cvc">
                  <div class="fw700">CVC</div>
                  <cleave id="stripe-cvc"
                    class="donate-form-input"
                    name="cvc"
                    size="4"
                    maxlength="4"
                    placeholder="123"
                    v-model="form.cvc"
                    v-validate="'required|min:3'"
                    data-vv-validate-on="blur"
                    @blur.native="validate('cvc')"
                    :options="formOptions.cvc"></cleave>
                  <div class="donate-form-error">{{errors.first('cvc')}}</div>
                </label>
              </div>
              <div class="donate-form-section donate-form-personal">
                <label class="donate-form-field donate-form-field-name mt1-sm mt1-md" for="stripe-cardholder">
                  <div class="fw700">Full Name</div>
                  <input id="stripe-cardholder"
                    class="donate-form-input"
                    name="fullName"
                    type="text"
                    size="19"
                    placeholder="John Doe"
                    v-model="form.fullName"
                    v-validate="'required'">
                  <div class="donate-form-error">{{errors.first('fullName')}}</div>
                </label>
                <label class="donate-form-field donate-form-field-email mt1-sm mt1-md" for="stripe-email">
                  <div class="fw700">Email</div>
                  <input id="stripe-email"
                    class="donate-form-input"
                    name="email"
                    type="email"
                    placeholder="john.doe@example.com"
                    v-model="form.email"
                    v-validate="'required|email'">
                  <div class="donate-form-error">{{errors.first('email')}}</div>
                </label>
              </div>
              <div class="donate-button button button-normal mt2"
                tabindex="0"
                :class="{ 'button-disabled': !form.amount}"
                @click="submit">
                  <input type="hidden" name="m1" value="z3klJjIwuPI8kNonBp0Rl7kvJaaFGMrV68h0j8Fn" />
                  <input type="hidden" name="m2" value="ej6KLOWR5QXg5DhbycTOjrUz9GU2HT2FDCRuH6lA" />
                  <span key="default">Donate<span v-if="form.amount"> ${{form.amount}}</span><span v-if="form.monthly"> Monthly</span></span>
                  <div class="loader"><div></div></div>
<!--                   <span key="success"><i class="material-icons md-24">check</i> Thank You!</span> -->
                  <!-- <span key="error"><i class="material-icons md-24">error</i> Something Went Wrong</span> -->
                </div>
              <div id="donate-form-errmsg" class="donate-form-error">Error text describing server-side errors coming through</div>
              <div class="donate-form-success">Your donation has been processed - Thank you!</div>
            </div>
          </div>
        </div>
        <div class="cols-5 offset-1 mt2-sm mt0-md">
          <p class="p fw700">Your donations go a long way!</p>
          <p class="small-p mt1">Your donation helps us <b>rescue</b> the oppressed, <b>redeem</b> the broken, and <b>restore</b> the hurting.  We cannot do this work without you!</p>
          <p class="fw700 subsection">Prefer Paypal?</p>
          <p class="small-p">Click on the paypal button below to donate to us over Paypal. You can also send money to us over Paypal at out email: info@unitethebride.com</p>
          <form id="paypal" action="https://www.paypal.com/cgi-bin/webscr" method="post" target="_blank">
            <input type="hidden" name="cmd" value="_s-xclick">
            <input type="hidden" name="hosted_button_id" value="WYHHKKRW9WDGJ">
            <input type="image" src="https://www.paypalobjects.com/en_US/i/btn/btn_donateCC_LG.gif" border="0" name="submit" alt="PayPal - The safer, easier way to pay online!">
            <img alt="" border="0" src="https://www.paypalobjects.com/en_US/i/scr/pixel.gif" width="1" height="1">
          </form>
          <p class="fw700 subsection">Send checks, or say hi!</p>
          <p class="small-p">Unite the Bride<br />6547 N Academy Blvd #535<br />Colorado Springs, CO 80918</p>
        </div>
      </div>
    </div>
  </section>
</template>

<script>
import Cleave from 'vue-cleave-component'
import DonateApi from '@/donateApi'

export default {
  components: {
    Cleave
  },

  inject: ['$validator'],

  data() {
    return {
      form: {
        amount: null,
        cardNumber: null,
        expiration: null,
        cvc: null,
        fullName: null,
        email: null,
        monthly: false
      },
      formOptions: {
        amount: {
          numeral: true,
          prefix: '$',
          rawValueTrimPrefix: true,
          noImmediatePrefix: true
        },
        cardNumber: {
          creditCard: true
        },
        expiration: {
          date: true,
          datePattern: ['m', 'y']
        },
        cvc: {
          creditCard: true
        }
      },
      donateAmounts: [
        { amount: 3 },
        { amount: 10 },
        { amount: 20 },
        { amount: 50 },
        { amount: 100 },
        { amount: 250 }
      ]
    }
  },

  methods: {
    setAmount(amount) {
      this.form.amount = amount
    },

    validate(field) {
      this.$validator.validate(field)
    },

    submit() {
      DonateApi.charge(this.form)
        .then(msg => {

        })
        .catch(err => {

        })
    }
  }
}
</script>

<style lang="scss">
@import '~@/styles/media';
@import '~@/styles/colors';

.donate-method {
  display: flex;
  align-items: flex-start;
}

.donate-method-img {
  display: block;
  width: percentage(1/3);
  margin-right: 1rem;
}

.donate-method-payment-card {
  transform: translateX(-1rem);

  @include md {
    transform: translateX(0rem);
  }
}

.donate-method p {
  margin: 0;
}

.donate-form-section {
  display: flex;
  flex-direction: column;

  @include lg {
    flex-flow: row;
  }
}

.donate-form-amount-field {
  display: flex;
  flex-flow: column;

  @include lg {
    align-items: flex-start;
  }
}

.donate-form-amount-buttons {
  display: flex;
  flex-direction: column;

  @include md {
    flex-flow: row wrap;
    margin-top: 0.5em;
  }
}

.donate-form-amount-button {
  margin-top: 1em;

  @include md {
    flex-basis: calc(#{percentage(1/3)} - #{(1/3)}em);
    margin-top: 0.5em;
    margin-right: 0.5em;

    &:nth-child(3),
    &:nth-child(6) {
      margin-right: 0;
    }
  }

  @include xl {
    flex-basis: auto;
    margin-top: auto;

    &:nth-child(3),
    &:nth-child(6) {
      margin-right: 0.5em;
    }
  }
}

.donate-form-field {
  flex: 1;

  @include lg {
    &+& {
      margin-left: 1rem;
    }
  }
}

.donate-form-field-card-number {
  flex: 2;
}

.donate-form-input {
  width: 100%;
  padding: 0.5rem 1rem;
  box-sizing: border-box;
  font-size: 18px;
  border: 1px solid map-get($colors, gray3);
  border-radius: 6px;
}

.donate-form-input-amount {
  font-size: 24px;
}

.donate-button {
  display: block;

  @include lg {
    display: inline-block;
  }
}

.donate-button i {
  transform: translateY(-2px);
}

.donate-form-error {
  font-size: 0.75em;
  color: map-get($colors, red6);
  display: none;
}

.donate-form-success {
  font-size: 1.2em;
  display: none;
  font-weight: bold;
  color: #295d18;
  text-align: center;
  text-decoration: underline;
}

.donate-form-monthly {
  padding: 0.5em 1em 0.5em 0.5em;
  background-color: map-get($colors, gray1);
  border-radius: 5px;

  &:hover {
    background-color: map-get($colors, gray2);
  }
}

#donate #paypal {
  text-align: center;
}

#donate p.subsection {
  margin: 1em 0 0 0;
}

</style>



// WEBPACK FOOTER //
// src/components/Donate.vue